import { EServiceType, TAppState } from '../../types';
import { NBSP } from '../../constants';
import * as moment from 'moment';
import { selectBuyPackageModalData, selectBuyPackageModalServices, selectIsSubscription } from '../buyPackageModal';

const SERVICES_WITH_POINTS = [EServiceType.Top, EServiceType.Premium, EServiceType.Auction];

export function selectSuccessScreenDescription(state: TAppState): string {
  const { endDate } = selectBuyPackageModalData(state);
  const services = selectBuyPackageModalServices(state);
  const isSubscription = selectIsSubscription(state);

  const hasPublications = !!services.find(s => !SERVICES_WITH_POINTS.includes(s.serviceType));
  const hasAuctionPoints = !!services.find(s => SERVICES_WITH_POINTS.includes(s.serviceType));

  const packageName = isSubscription ? 'подписки' : 'пакета';

  const tillDate = endDate
    ? moment(endDate, 'DD.MM.YYYY').toDate().toLocaleString('ru', {
        month: 'long',
        day: 'numeric',
      })
    : '';

  const result = ['Можете'];

  if (hasPublications) {
    result.push('размещать объявления');
  }

  if (hasPublications && hasAuctionPoints) {
    result.push('и');
  }

  if (hasAuctionPoints) {
    result.push('тратить баллы');
  }

  result.push(`из${NBSP}${packageName}`);

  if (tillDate) {
    result.push(`до ${tillDate}`.replace(/\s/g, NBSP));
  }

  return result.join(' ');
}
